import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import type { Locale } from '../locale';
import { bg } from './resources/bg';
import { en } from './resources/en';

export const i18n = i18next.createInstance();

export function initI18n(locale: Locale): typeof i18n {
  void i18n.use(initReactI18next).init({
    resources: { en: { translation: en }, bg: { translation: bg } },
    lng: locale,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    returnNull: false,
    initAsync: false,
  });
  return i18n;
}
